/**
 * @generated SignedSource<<99c2ecb5a40df461ca6972e89af01f7d>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type UserNavigatorView_query$data = {
  readonly currentUser: {
    readonly profile: {
      readonly photos: {
        readonly nodes: ReadonlyArray<{
          readonly storageObject: {
            readonly bucket: string | null | undefined;
            readonly key: string | null | undefined;
          } | null | undefined;
        } | null | undefined>;
      };
      readonly rowId: any;
      readonly userId: any;
    } | null | undefined;
    readonly unviewedLikesCount: number | null | undefined;
    readonly unviewedMatchMessagesCount: number | null | undefined;
    readonly unviewedMatchesCount: number | null | undefined;
    readonly unviewedSystemMessagesCount: number | null | undefined;
  } | null | undefined;
  readonly currentUserUnreadCount: number | null | undefined;
  readonly " $fragmentType": "UserNavigatorView_query";
};
export type UserNavigatorView_query$key = {
  readonly " $data"?: UserNavigatorView_query$data;
  readonly " $fragmentSpreads": FragmentRefs<"UserNavigatorView_query">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "UserNavigatorView_query",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "User",
      "kind": "LinkedField",
      "name": "currentUser",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Profile",
          "kind": "LinkedField",
          "name": "profile",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "PhotoConnection",
              "kind": "LinkedField",
              "name": "photos",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Photo",
                  "kind": "LinkedField",
                  "name": "nodes",
                  "plural": true,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "StorageObject",
                      "kind": "LinkedField",
                      "name": "storageObject",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "bucket",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "key",
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "rowId",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "userId",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "unviewedLikesCount",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "unviewedMatchesCount",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "unviewedMatchMessagesCount",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "unviewedSystemMessagesCount",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "currentUserUnreadCount",
      "storageKey": null
    }
  ],
  "type": "Query",
  "abstractKey": null
};

(node as any).hash = "71218e9b4787f9661c4f31d32d06b8bd";

export default node;
